import './index_web.css';
import { Key, useEffect, useState } from 'react';
import { useRouteLocation } from 'react-router-stack';
import { View } from '../../../component';
import { getTeamPreviewPlayer } from '../../../utilities/helper';
import { TeamPreviewPlayerRow, TeamPreviewPlayerHeader, TeamPreviewHeader } from '../../component';
import DefaultContainer from '../../../container/default_container';
import constants from '../../../constants';

const TeamPreviewWeb = () => {
  const { state = {} } = useRouteLocation();
  const [teamPreviewData, setTeamPreviewData] = useState({
    userTeamScore: 0,
    sectionPlayerList: []
  } as any);

  const [lineupsOut, setLineupsOut] = useState(false);

  const {
    teamData = {},
    item: matchItem = {},
    completed = false,

    matchAllPlayersList = [],
    gameType = ''
  } = state;

  const { teamA = {}, teamB = {} } = matchItem;

  const {
    players = [],
    captainId = '',
    viceCaptainId = '',
    teamNumber = 1,
    username = ''
  } = teamData;

  useEffect(() => {
    if (!completed) {
      let playingPlayersList = [];
      playingPlayersList = matchAllPlayersList.filter(
        (player: { playingEleven: boolean }) => player.playingEleven === true
      );
      setLineupsOut(playingPlayersList.length >= 15);
    }

    setTeamPreviewData(() =>
      getTeamPreviewPlayer({
        players,
        matchAllPlayersList,
        teamA,
        teamB,
        captainId,
        viceCaptainId,
        gameType
      })
    );
  }, []);

  const renderItemPlayers = (item: any) => {
    return (
      <TeamPreviewPlayerRow
        key={item.id}
        item={item}
        completed={completed}
        lineupsOut={lineupsOut}
        isTeamTeamA={teamA?.teamId === item?.teamId ? true : false}
        gameType={gameType}
      />
    );
  };

  const renderList = (list = []) => {
    return (
      <View
        className="team-preview-list-container"
        style={{ width: gameType === constants.GameType.FANTASY_CRICKET ? '50%' : '' }}>
        {list.map(renderItemPlayers)}
      </View>
    );
  };

  const renderTeamPreview = (item: { title: Key | null | undefined; data: any }, index: any) => {
    return (
      <View className={'team-preview-list-wrapper'} key={item + index}>
        <TeamPreviewPlayerHeader key={item.title} title={item.title} />
        {renderList(item.data)}
      </View>
    );
  };
  return (
    <DefaultContainer>
      <View className="teamPreview__wrapper">
        <TeamPreviewHeader
          username={username}
          teamA={teamA}
          teamB={teamB}
          teamNumber={teamNumber}
          userTeamScore={teamPreviewData['userTeamScore']}
          completed={completed}
        />
        {gameType === constants.GameType.FANTASY_CRICKET && (
          <div style={{ position: 'relative', marginBottom: '200px', marginTop: '15px' }}>
            <img src={constants.Images.cricketTeamPreviewBg} width={'100%'} />
            <div className="cricket_team_card_preview_container">
              {teamPreviewData['sectionPlayerList'].map(renderTeamPreview)}
            </div>
          </div>
        )}
        {gameType === constants.GameType.FANTASY_FOOTBALL && (
          <div style={{ position: 'relative', marginBottom: '200px', marginTop: '15px' }}>
            <img src={constants.Images.footballTeamPreviewBg} width={'100%'} />
            <div className="cricket_team_card_preview_container">
              {teamPreviewData['sectionPlayerList'].map(renderTeamPreview)}
            </div>
          </div>
        )}
      </View>
    </DefaultContainer>
  );
};
export default TeamPreviewWeb;
